import type { FC } from 'react';

import { HorizontalButtonContainer } from 'features/call/call-details/styles';
import {
  CallDetailsButtonDeafDisconnect,
  CallDetailsButtonDeafThreeDotMenu,
} from 'features/call/call-details/components';

interface CallDetailsDeafConnectedButtonsProps {
  isLoadingDeaf: boolean;
  isThreeDotsMenuButtonPresent: boolean;
}

export const CallDetailsDeafConnectedButtons: FC<
  CallDetailsDeafConnectedButtonsProps
> = ({ isLoadingDeaf, isThreeDotsMenuButtonPresent }) => (
  <HorizontalButtonContainer>
    <CallDetailsButtonDeafDisconnect isLoading={isLoadingDeaf} />
    {isThreeDotsMenuButtonPresent && <CallDetailsButtonDeafThreeDotMenu />}
  </HorizontalButtonContainer>
);
